import { useState } from "react";
import { Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";

const ListField = ({ variables, setVariables, name, first, second }) => {
  const [showList, setShowList] = useState(true);
  const [tempArr, setTempArr] = useState(
    variables[second].split(" ").map((i) => parseInt(i.trim()))
  );
  const textbausteine = useSelector((st) => st.textbausteine);
  const tbFilteredType = textbausteine.filter((tb) => tb.type === name);
  const tbFilteredPunkte = tbFilteredType.filter((tb) => {
    // console.log("###############", tb.punkte, { variables, first, tb });
    return tb.punkte.includes(variables[first]);
  });

  const displayed = tbFilteredType;
  const notenArr = Array.from(new Set(displayed.map((d) => d.punkte))).sort(
    (a, b) => (a < b ? 1 : -1)
  );

  console.log({
    displayed,
    variables,
    setVariables,
    name,
    textbausteine,
    tbFilteredType,
    tbFilteredPunkte,
    notenArr,
  });
  console.log({ textbausteine });

  const handleClick = (e) => {
    const { id } = e.target.parentElement;
    console.log(id);
    const arr = variables[second].split(" ").map((i) => parseInt(i.trim()));
    console.log({ arr });
    arr.push(parseInt(id));
    const newArr = Array.from(new Set(arr));
    setTempArr([...newArr]);
    const newString = newArr.join(" ").replace("NaN", "").trim();
    console.log({ newString, newArr });
    setVariables((vars) => {
      return { ...vars, [second]: newString };
    });
  };
  const handleDelete = (e) => {
    e.preventDefault();
    console.log(+e.target.id);
    const valueArr = variables[second]
      .split(" ")
      .map((i) => parseInt(i))
      .filter((i) => i !== +e.target.id);
    setTempArr(valueArr);
    setVariables({ ...variables, [second]: valueArr.join(" ") });
  };

  const tbArr1 = variables[second]
    ? variables[second].split(" ").map((i) => parseInt(i))
    : [];
  const tbArr2 = tbArr1.map((id) => textbausteine.find((tb) => tb.id === id));
  console.log({ tbArr2 });
  const displayedTxt = tbArr2.map((tb) => (
    <p key={tb.id}>
      <button
        id={tb.id}
        className="btn btn-outline-danger mr-2 "
        onClick={(e) => handleDelete(e)}
      >
        x
      </button>
      {tb.text} (Punkte: {tb.punkte}, Baustein {tb.number})
    </p>
  ));
  // console.log({ tbArr1, tbArr2 });
  // console.log(variables);
  console.log({ showList });
  return (
    <div>
      {/* <p>{hint}</p> */}
      {/* <p>{variables[second]}</p> */}
      {tbArr2.length ? (
        <div
          className="mt-2 p-3"
          style={{ border: "1px solid grey", borderRadius: "5px" }}
        >
          {tbArr1.length > 0 ? <h6>Ausgewählte Textbausteine</h6> : null}

          {displayedTxt}
          <Row>
            <Col>
              {showList ? (
                <button
                  className="btn btn-outline-dark"
                  onClick={() => setShowList(false)}
                >
                  OK, Auswahl der Texbausteine beenden
                </button>
              ) : null}
            </Col>
            <Col>
              <button
                className="btn btn-outline-dark"
                onClick={() => {
                  setShowList(true);
                  setVariables((vars) => {
                    return { ...vars, [second]: "" };
                  });
                  setTempArr([]);
                }}
              >
                Alle löschen und neu eingeben
              </button>
            </Col>

            <Col></Col>
          </Row>
        </div>
      ) : null}
      {showList ? (
        <Table>
          <thead>
            <tr>
              <th>Punkte</th>
              <th>Nummer</th>
              <th>Textbaustein</th>
            </tr>
          </thead>
          <tbody>
            {displayed.map((tb, idx) => {
              const color = tempArr.includes(tb.id) ? "grey" : "black";
              return (
                <>
                {(idx > 0 && displayed[idx - 1].punkte !== displayed[idx].punkte) ? <tr style={{borderTop:"3px solid black"}}></tr>:null}
                <tr
                  key={tb.id}
                  id={tb.id}
                  onClick={(e) => handleClick(e)}
                  style={{ color }}
                >
                  <td>{tb.punkte}</td>
                  <td>{tb.number}</td>
                  <td>{tb.text}</td>
                </tr>
                </>
              );
            })}
          </tbody>
        </Table>
      ) : null}
      {/* {showList ? (
        <ToggleDarkButton
          props={{
            bol: !showAll,
            func: () => setShowAll(!showAll),
            defaultText: "Alle Textbausteine anzeigen",
            backText: "Nur zur Punktzahl passende Textbausteine anzeigen",
          }}
        />
      ) : null} */}
    </div>
  );
};
export default ListField;
